import WalletTemplates from '../../../../store/wallets/templates';

angular
    .module('festzelt-os.modules.wallets')
    .factory('WalletTemplates', [
        '$injector',
        'WalletTemplate',
        ($injector, WalletTemplate) => new WalletTemplates(WalletTemplate, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/store/wallet-templates.js